module.exports = __webpack_public_path__ + "img/quizmayhem_banner_music.46b49412.jpg";